import React, { useEffect, useState } from 'react';
import './TextInput.scss';

export interface TextInputProps {
  label: string;
  value?: string;
  style?: any;
  onChange: Function;
  error?: string;
  password?: boolean;
  autoComplete?: boolean;
  formatter?: Function;
  type?: string;
  editable?: boolean;
}

const TextInput = ({
  label,
  value = '',
  style = {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  error,
  autoComplete = false,
  formatter,
  type = 'text',
  editable = true
}: TextInputProps) => {
  const [data, setData] = useState(value);
  useEffect(() => {
    setData(value);
  }, [value]);
  return (
    <div className="group" style={style}>
      {editable ? (
        <input
          autoComplete={autoComplete ? 'on' : 'off'}
          value={data}
          className="text-input"
          type={type}
          required
          onBlur={() => {
            if (formatter) {
              const formattedValue = formatter(data);
              setData(formattedValue);
              onChange(formattedValue);
            } else {
              setData(data);
              onChange(data);
            }
          }}
          onChange={e => {
            setData(e.target.value);
          }}
        />
      ) : (
        <div className="set-value">{value}</div>
      )}
      <span className="highlight"></span>
      <span className="bar"></span>
      <label className={`text-input-label ${editable ? '' : 'active'}`}>
        {label}
      </label>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default TextInput;
